import React from "react";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Table, Radio, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Endpoints from "../../api/endpoints.js";
import PageRoutes from "../../utils/routes.js";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import EndpointFunctions from "../../utils/Functions/endpointFunctions.js";
import { ApplicationStatusColumns } from "./ApplicationStatusColumns";

const activeOrAllApplicationStatus = [
  {
    label: "Tüm Uygulama Durumları",
    value: Endpoints.getAllApplicationStatuses,
  },
  {
    label: "Bakımda Olan Uygulama Durumları",
    value: Endpoints.getAllUnderMaintenance,
  },
];

const ApplicationStatutes = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [radioValue, setRadioValue] = useState(
    Endpoints.getAllApplicationStatuses
  );
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchAppStatusData({ endpoint: radioValue });
  }, [radioValue]);

  const fetchAppStatusData = async ({ endpoint }) => {
    setTableLoading(true);
    const result = await EndpointFunctions.fetchData({
      endpointURL: endpoint,
      axiosPrivate: axiosPrivate,
    });

    if (result.success) {
      console.log("---RESULT---", result);
      const appStatusData = result.data;
      setTableData(() => appStatusData);
      setTableLoading(false);
    } else {
      setTableLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const handleRadioChange = ({ target: { value } }) => {
    setRadioValue(value);
  };

  const goToUpdatePage = ({ record }) => {
    const id = record.id;
    let path = `${PageRoutes.updateApplicationStatus}/${id}`;
    navigate(path);
  };

  const deleteApplicationStatus = ({ record }) => {
    const id = record.id;
    Modal.confirm({
      title: "Uygulama Durumunu Sil",
      icon: <ExclamationCircleFilled />,
      content: `Uygulama Durumu ID:${record.id} silinecektir. Emin misiniz?`,
      onOk() {
        return new Promise((resolve, reject) => {
          EndpointFunctions.deleteRecord({
            recordId: id,
            axiosPrivate: axiosPrivate,
            endpointURL: Endpoints.deleteApplicationStatus,
          })
            .then((response) => {
              resolve();
              if (response.success) {
                showModal("Başarılı", "Uygulama Durumu Silindi.", () => {
                  closeModal();
                });
                setTableLoading(true);
                fetchAppStatusData({ endpoint: radioValue });
              } else {
                showModal(response.errorTitle, response.errorMessage, () => {
                  closeModal();
                });
              }
            })
            .catch((err) => {
              showModal("Hata", "İşlem sırasında bir hata oluştu.", () => {
                closeModal();
              });
              reject(err);
            });
        });
      },
    });
  };

  return (
    <>
      <Radio.Group
        options={activeOrAllApplicationStatus}
        onChange={handleRadioChange}
        value={radioValue}
      />

      <div style={{ height: 20 }} />

      <Table
        dataSource={tableData}
        columns={ApplicationStatusColumns(
          goToUpdatePage,
          deleteApplicationStatus
        )}
        scroll={{ x: true }}
        loading={tableLoading}
      />

      <ModalComponent></ModalComponent>
    </>
  );
};

export default ApplicationStatutes;
